import { transformComponent } from '../../__builtins__/shared'
import { connect, mapProps, mapReadPretty } from '@formily/vue'
import RichTimeRangePicker from './layout.vue'

const TransformRichTimeRangePicker = transformComponent(RichTimeRangePicker, {
  change: 'input',
})

export const TimeRangePicker = connect(
  TransformRichTimeRangePicker,
  mapProps({ readOnly: 'readonly' }),
  mapReadPretty(TransformRichTimeRangePicker),
)

export default TimeRangePicker
